import classNames from 'classnames';

import { Skeleton } from '@ui/Skeleton';

import s from './ProfileSocialFeedPostCard.sss';

interface Props {
  className?: string,
}

export const ProfileSocialFeedPostCardSkeleton: React.FC<Props> = ({
  className,
}) => (
  <div className={classNames(s.root, className)}>
    <div className={s.photoHolder}>
      <Skeleton
        className={s.photo}
        width="100%"
        height="100%"
      />
    </div>

    <div className={s.author}>
      <div>
        <Skeleton
          type="circle"
          width="32px"
          height="32px"
        />
      </div>

      <Skeleton
        width="50%"
        height="16px"
      />
    </div>
  </div>
);
